import eVidnovlennia from './views/repair.c.js';
export default eVidnovlennia;
